import {AmbryKeyActions} from "../const/ActionsConst";

const initialState = {
    show: false,
    error: undefined,
    clientId: undefined,
    clientSecret: undefined,
    hostAddress: undefined,
    grantType: undefined,
};

const ambryKey = (state = initialState, action) => {
    switch (action.type) {
        case AmbryKeyActions.SHOW_AMBRY_KEY_DIALOG:
            return {
                ...state,
                show: action.show,
            };
        case AmbryKeyActions.UPDATE_AMBRY_KEY_DATA:
            return {
                ...state,
                [action.field]: action.value,
            };
        case AmbryKeyActions.AMBRY_KEY_LOADED:
            return {
                ...state,
                clientId: action.data.clientId,
                clientSecret: action.data.clientSecret,
                hostAddress: action.data.hostAddress,
                grantType: action.data.grantType,
            }
        default:
            return state;
    }
};

export default ambryKey;